import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const DeleteUserDialog = ({ state, onChange, onClose, onConfirm }) => {
  const targetEmail = (state.user?.email || "").trim().toLowerCase();
  const provided = (state.confirmText || "").trim().toLowerCase();
  const isMatch = !!targetEmail && provided === targetEmail;
  return (
    <Dialog open={state.open} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent>
        {state.step === 1 && (
          <>
            <DialogHeader>
              <DialogTitle>Delete {state.user?.name}?</DialogTitle>
              <DialogDescription>
                This deletes <strong>{state.user?.email}</strong> and moves all their daily
                entries to the <strong>30-day Recovery bin</strong>. You can restore them
                from Admin → Recovery within that window.
              </DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <Button variant="ghost" onClick={onClose}>Cancel</Button>
              <Button
                variant="destructive"
                onClick={() => onChange({ ...state, step: 2, confirmText: '' })}
                data-testid="delete-first-confirm"
              >
                Yes, I&apos;m Sure
              </Button>
            </DialogFooter>
          </>
        )}
        {state.step === 2 && (
          <>
            <DialogHeader>
              <DialogTitle>Final Confirmation</DialogTitle>
              <DialogDescription>
                Type the target user&apos;s email{' '}
                <span className="font-bold text-destructive">{state.user?.email}</span> below to
                confirm. Entries will be restorable from Admin → Recovery for 30 days.
              </DialogDescription>
            </DialogHeader>
            <Input
              value={state.confirmText}
              onChange={(e) => onChange({ ...state, confirmText: e.target.value })}
              placeholder={state.user?.email || "Type the email"}
              className="font-mono"
              data-testid="delete-confirm-input"
              autoFocus
            />
            <DialogFooter>
              <Button variant="ghost" onClick={onClose}>Cancel</Button>
              <Button
                variant="destructive"
                onClick={onConfirm}
                disabled={!isMatch}
                data-testid="delete-final-confirm"
              >
                Delete User
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
